export default "__VITE_ASSET__CxGYiURb__"